import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";

import ControllerDataForm from "./DataForm";
import ControllerInfoForm from "./InfoForm";


const ControllerBlockForm = ({ data, requireUrl, setPopup, yandexMapApi }) => {

    if( gpCommon.getArray( data['form'], null ) !== null ) {
        return(
            <div className="blockForm">
                {gpCommon.getArray( data['form'], [] ).map( ( item, index ) => renderItem( item, index, false ) )}
            </div>
        );
    }

    return null;

    function renderItem( item, index, inRow ) {
        if( gpCommon.getArray( item, null ) !== null ) {

            return(
                <div key={gpCommon.getString( item['id'], 'block' + index )} className={inRow ? "flex" : "flexRow"}>
                    {gpCommon.getArray( item, [] ).map( ( subitem, index ) => renderItem( subitem, index, !inRow ) )}
                </div>
            );

        }
        else {
            let dataType = item !== null ? gpCommon.getString( item['type'], null ) : null;

            return (
                <div key={gpCommon.getString( item['id'], '' )}>
                    {dataType === 'dataForm' && <ControllerDataForm data={item} requireUrl={requireUrl} setPopup={setPopup} inBlock={true} />}
                    {dataType === 'infoForm' && <ControllerInfoForm data={item} requireUrl={requireUrl} inBlock={true} yandexMapApi={yandexMapApi} />}
                </div>
            );
        }
    }

}
ControllerBlockForm.propTypes = {
    data: PropTypes.object.isRequired,
    requireUrl: PropTypes.func.isRequired,
    setPopup: PropTypes.func.isRequired,
    yandexMapApi: PropTypes.any
};
export default ControllerBlockForm;
